<template>
  <p-edit-topic-form
    :is-request-pending="isUpdateRequestPending"
    :is-request-failed="isUpdateRequestFailed"
    :item="item"
    @submit="update"
  />
</template>

<script>
import { mapState } from 'vuex';
import CreateOrEditForm from './_CreateOrEdit';

export default {
  components: {
    'p-edit-topic-form': CreateOrEditForm
  },
  meta: {
    title: 'Manage Topic'
  },
  computed: {
    ...mapState({
      item: s => s.topics.item,
      isUpdateRequestPending: s => s.topics.isUpdateRequestPending,
      isUpdateRequestFailed: s => s.topics.isUpdateRequestFailed
    })
  },
  watch: {
    '$route.params': {
      handler() {
        this.$store.dispatch('topics/getById', this.$route.params.id);
      },
      immediate: true
    }
  },
  methods: {
    async update(data) {
      try {
        await this.$store.dispatch('topics/update', { ...data, id: this.$route.params.id });

        this.$toast.success({
          title: 'Update completed',
          message: `Topic was updated.`
        });
        this.$router.push({ path: `/` });
      } catch (e) {
        this.$toast.error({
          title: 'Update failed',
          message: `Please, try again later or contact our development team.`
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
